<template>
  <div :class="$style.timelineWrapper">
    <UiTimeLine
      v-model="activePage"
      :lines="nav"
      :class="$style.navigation"
    />
  </div>
  <NuxtPage />
</template>

<script lang="ts" setup>
import type { TimeLineItem } from '@/components/ui/TimeLine/index.js'

const { t } = useI18n();

const route = useRoute();

const activePage = computed<string>(() => route.fullPath);
const nav = ref<TimeLineItem[]>([
  {
    label: t('footerNav.terms'),
    to: '/documents/terms',
    value: '/documents/terms',
  }, {
    label: t('footerNav.agree'),
    to: '/documents/ua',
    value: '/documents/ua',
  }, {
    label: t('footerNav.privacy'),
    to: '/documents/privacy',
    value: '/documents/privacy',
  },
]);
</script>

<style lang="scss" module>
  .navigation {
    max-width: 574px;
    margin: 0 auto;
  }

  .timelineWrapper {
    @media (max-width: 767px) {
      overflow-x: auto;
      margin-bottom: 40px;
      padding: 0 30px 6px 30px;
    }
  }
</style>